import React from "react";
import { BarChart } from '@mui/x-charts/BarChart';
import Box from '@mui/material/Box';
import { Stack, Typography } from "@mui/material";
import { statuses } from "../ApiSevices/DashboardApis";
interface BarChartProps {
    barChartCountData: {
        categories: string[];
        series: { name: string; data: number[]; color: string }[];
    } | null;
    loading: boolean;
}

const BarChartComponent: React.FC<BarChartProps> = ({ barChartCountData, loading }) => {
    return (
        <Box sx={{ position: "relative", width: "100%", height: 310, backgroundColor: "#fff", borderRadius: 2, p: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                {statuses?.map((status, index) => (
                    <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: status.color,
                                borderRadius: 0.5,
                            }}
                        />
                        <Typography variant="body2" sx={{ fontSize: "11px" }}>
                            {status?.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
            {barChartCountData && (
                <>
                    <BarChart
                        series={barChartCountData?.series?.map(s => ({
                            ...s,
                            showMark: true, // Show markers on bars
                            stroke: s.color,
                            showValue: true, // Show values above bars
                        }))}
                        xAxis={[{ scaleType: 'band', data: barChartCountData.categories }]}
                        height={310}
                        grid={{ vertical: true, horizontal: true }} // Add grid lines
                        sx={{ marginTop: '-30px' }}
                    />

                    {/* Legend Section */}
                    {barChartCountData?.series && barChartCountData?.series?.length > 0 && (
                        <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
                            {barChartCountData?.series?.map((s, index) => (
                                <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ width: 12, height: 12, bgcolor: s?.color || "#000", borderRadius: "50%", mr: 1 }} />
                                    <Typography variant="body2" sx={{ color: "#333" }}>{s?.name}</Typography>
                                </Box>
                            ))}
                        </Stack>
                    )}

                </>
            )}
        </Box>
    );
};

export default BarChartComponent;
